const notifications = {
  search_contacts: 'Phone / Email',
};

export default notifications;
